// extracted by mini-css-extract-plugin
export var errorsContainer = "_u5-1";
export var link = "_u5-0";